var _mask, _rect, _path, _mask2, _rect2, _path2, _mask3, _rect3, _path3, _mask4, _rect4, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplatePromptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 49,
    viewBox: "0 0 52 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3389_35144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 0.25,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 0.25,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214,
    stroke: "#1E8B7C",
    strokeWidth: 3.4,
    mask: "url(#path-1-inside-1_3389_35144)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5159 8.875H1.35519C1.02841 8.875 0.715005 8.74518 0.483933 8.51411C0.252861 8.28304 0.123047 7.96964 0.123047 7.64286V1.48214C0.123047 1.15536 0.252861 0.841958 0.483933 0.610886C0.715005 0.379815 1.02841 0.25 1.35519 0.25H7.5159C7.84269 0.25 8.15609 0.379815 8.38716 0.610886C8.61823 0.841958 8.74805 1.15536 8.74805 1.48214V7.64286C8.74805 7.96964 8.61823 8.28304 8.38716 8.51411C8.15609 8.74518 7.84269 8.875 7.5159 8.875ZM1.35519 1.48214V7.64286H7.5159V1.48214H1.35519ZM3.81948 6.63373L2.15608 5.00299L3.01858 4.12201L3.81948 4.90504L5.85251 2.89233L6.71501 3.76838L3.81948 6.63312V6.63373Z",
    fill: "#1E8B7C"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_3389_35144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 13.375,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 13.375,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214,
    stroke: "#1E8B7C",
    strokeWidth: 3.4,
    mask: "url(#path-3-inside-2_3389_35144)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5159 22H1.35519C1.02841 22 0.715005 21.8702 0.483933 21.6391C0.252861 21.408 0.123047 21.0946 0.123047 20.7679V14.6071C0.123047 14.2804 0.252861 13.967 0.483933 13.7359C0.715005 13.5048 1.02841 13.375 1.35519 13.375H7.5159C7.84269 13.375 8.15609 13.5048 8.38716 13.7359C8.61823 13.967 8.74805 14.2804 8.74805 14.6071V20.7679C8.74805 21.0946 8.61823 21.408 8.38716 21.6391C8.15609 21.8702 7.84269 22 7.5159 22ZM1.35519 14.6071V20.7679H7.5159V14.6071H1.35519ZM3.81948 19.7587L2.15608 18.128L3.01858 17.247L3.81948 18.03L5.85251 16.0173L6.71501 16.8934L3.81948 19.7581V19.7587Z",
    fill: "#1E8B7C"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_3389_35144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 26.5,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 26.5,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214,
    stroke: "#1E8B7C",
    strokeWidth: 3.4,
    mask: "url(#path-5-inside-3_3389_35144)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5159 35.125H1.35519C1.02841 35.125 0.715005 34.9952 0.483933 34.7641C0.252861 34.533 0.123047 34.2196 0.123047 33.8929V27.7321C0.123047 27.4054 0.252861 27.092 0.483933 26.8609C0.715005 26.6298 1.02841 26.5 1.35519 26.5H7.5159C7.84269 26.5 8.15609 26.6298 8.38716 26.8609C8.61823 27.092 8.74805 27.4054 8.74805 27.7321V33.8929C8.74805 34.2196 8.61823 34.533 8.38716 34.7641C8.15609 34.9952 7.84269 35.125 7.5159 35.125ZM1.35519 27.7321V33.8929H7.5159V27.7321H1.35519ZM3.81948 32.8837L2.15608 31.253L3.01858 30.372L3.81948 31.155L5.85251 29.1423L6.71501 30.0184L3.81948 32.8831V32.8837Z",
    fill: "#1E8B7C"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_3389_35144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 39.625,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.293,
    y: 39.625,
    width: 37.5804,
    height: 8.625,
    rx: 1.23214,
    stroke: "#1E8B7C",
    strokeWidth: 3.4,
    mask: "url(#path-7-inside-4_3389_35144)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5159 48.25H1.35519C1.02841 48.25 0.715005 48.1202 0.483933 47.8891C0.252861 47.658 0.123047 47.3446 0.123047 47.0179V40.8571C0.123047 40.5304 0.252861 40.217 0.483933 39.9859C0.715005 39.7548 1.02841 39.625 1.35519 39.625H7.5159C7.84269 39.625 8.15609 39.7548 8.38716 39.9859C8.61823 40.217 8.74805 40.5304 8.74805 40.8571V47.0179C8.74805 47.3446 8.61823 47.658 8.38716 47.8891C8.15609 48.1202 7.84269 48.25 7.5159 48.25ZM1.35519 40.8571V47.0179H7.5159V40.8571H1.35519ZM3.81948 46.0087L2.15608 44.378L3.01858 43.497L3.81948 44.28L5.85251 42.2673L6.71501 43.1434L3.81948 46.0081V46.0087Z",
    fill: "#1E8B7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatePromptIcon);
export default __webpack_public_path__ + "static/media/template-prompt-icon.72c84ec1.svg";
export { ForwardRef as ReactComponent };